const state = {
    closeOnPressEscape:false,
    closeOnClickModal:false,
    // 当前分页 默认一页展示多少条数据
    pageSizes:[30,50,100],
    // 分页页数
    currentPageSize:30,
    elBtnSize:'small',
    // 弹框
    width:"500px",
    showClose:true,
    rootClientHeight:0,
    rootScrollHeight:0,
    rootClientWidth:0,
    tableHeight:0,
}

// getters
const getters = {}

// actions
const actions = {}

// mutations
const mutations = {
    // 更新数据
    updateElementData(state, payload) {
        state = Object.assign(state,payload)
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}
